import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import { Stack, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { getLabelByAccess } from "@entrilia/shared/utilities/accessHelper.ts";
import { AccessModeMenu } from "./AccessModeMenu.tsx";

import { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes.ts";

interface Props {
  access: ReportAccessType;
  allowedAccesses: ReportAccessType[];
  disabled: boolean;
  hasRemove?: boolean;
  onSelect: (access: ReportAccessType) => void;
  onRemove?: () => void;
}
export default function AccessModeMenuLabel({
  access,
  allowedAccesses,
  disabled,
  hasRemove,
  onSelect,
  onRemove,
}: Props) {
  const [open, setOpen] = useState(false);
  const [menuEl, setMenuEl] = useState<HTMLDivElement | null>(null);

  const canBeEdited = useMemo(() => {
    if (access === ReportAccessType.Owner) {
      if (allowedAccesses.includes(ReportAccessType.Owner)) {
        return true;
      }
      return false;
    }
    return true;
  }, [access, allowedAccesses]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Stack
        component="div"
        ref={(el) => {
          setMenuEl(el);
        }}
        direction={"row"}
        spacing={0.5}
        onClick={() => !disabled && setOpen(true)}
        sx={{ alignItems: "center", cursor: canBeEdited && !disabled ? "pointer" : "default" }}
      >
        <Typography variant="body2" color={disabled ? "textDisabled" : "textPrimary"}>
          {getLabelByAccess(access)}
        </Typography>
        {canBeEdited && <ArrowDropDownRoundedIcon color="action" />}
      </Stack>
      {canBeEdited && (
        <AccessModeMenu
          access={access}
          allowedAccesses={allowedAccesses}
          menuRef={menuEl}
          hasRemove={hasRemove}
          open={open}
          onSelect={onSelect}
          onRemove={onRemove}
          onClose={handleClose}
        />
      )}
    </>
  );
}
